import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BaseRequestAdminModal } from './BaseRequestAdminModal';
import { jsx as _jsx } from "react/jsx-runtime";
export function RequestAdminInstallModal(_ref) {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(BaseRequestAdminModal, Object.assign({}, rest, {
    adminInstall: true,
    help: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.productDetailsCard.cta.adminInstallModal.help"
    }),
    modalHeader: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.productDetailsCard.cta.adminInstallModal.header"
    }),
    subheader: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.productDetailsCard.cta.adminInstallModal.subheader"
    })
  }));
}